import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatMenuModule} from '@angular/material/menu';
import {HeaderComponent} from '@shared/components/header/header.component';
import {HeaderContainer} from '@shared/components/header/header.container';
import {LoaderMiniModule} from '@shared/components/loaders/loader-mini/loader-mini.module';
import {AmcIconifyModule, UserPermissionDirectiveModule} from 'amc-common-components';

@NgModule({
	declarations: [HeaderContainer, HeaderComponent],
	exports: [HeaderContainer],
	imports: [
		CommonModule,
		MatMenuModule,
		MatButtonModule,
		LoaderMiniModule,
		AmcIconifyModule,
		UserPermissionDirectiveModule,
		MatDialogModule,
	],
})
export class HeaderModule {}
